<template>
  <section class="content-section">
    <div class="container">
      <TableOfContents :toc="article.toc" />
      <ArticleSection :article="article" />
    </div>
  </section>
</template>

<script>
import ArticleSection from './ArticleSection/ArticleSection.vue';
import TableOfContents from './TableOfContents/TableOfContents.vue';

export default {
  components: {
    ArticleSection,
    TableOfContents,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ContentSection.scss';
</style>
